import { render } from "./NavBar.vue?vue&type=template&id=5a787f85&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5a787f85&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a787f85"

export default script